// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"9782d270","373":"c109d039","454":"0ac9ad7a","519":"46514d9e","900":"5133ea99"}[chunkId] + ".chunk.js";
};